import { render, staticRenderFns } from "./exhibition-special-guests.vue?vue&type=template&id=0a63aec0&scoped=true&"
import script from "./exhibition-special-guests.vue?vue&type=script&lang=js&"
export * from "./exhibition-special-guests.vue?vue&type=script&lang=js&"
import style0 from "./exhibition-special-guests.vue?vue&type=style&index=0&id=0a63aec0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a63aec0",
  null
  
)

export default component.exports